// extracted by mini-css-extract-plugin
export default {"root":"divider_root__klMZH"};